import React from 'react';
import styled from 'styled-components';
import { Dropdown as Component } from 'antd';

const Dropdown = styled(props => <Component {...props} />)``;

/** @component */
export default Dropdown;
